<template>
    <div class="modal fade" id="cancel-contract-modal" role="dialog" @click="$emit('close')">
      <div class="modal-dialog" @click.stop>
        <div v-if="canCancelContract" class="modal-content">
          <div class="modal-header bg-color-info">
            <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
          </div>
          <div class="modal-body">
            <p class="font-bold">セルモンプレミアムを解約しますか？</p>
            <div class="flexbox gap-10">
              <i class="fa fa-exclamation-triangle text-danger text-size-20" aria-hidden="true"></i>
              <p class="text-danger">
                すべてのプレミアム限定機能がただちに利用できなくなります。
                <br>
                解約の時点で機能停止となり、日割り・返金対応はございません。
              </p>
            </div>
            <p class="font-bold">解約後は自動的にベーシックプランへ切り替わります。</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-cancel text-white" data-dismiss="modal" @click="$emit('confirm')">解約する</button>
            <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">キャンセル</button>
          </div>
        </div>
        <div v-else class="modal-content">
          <div class="modal-header bg-color-info">
            <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
          </div>
          <div class="modal-body">
            <div class="flexbox gap-10" style="align-items: baseline;">
              <i class="fa fa-exclamation-triangle text-danger text-size-20" aria-hidden="true"></i>
              <div>
                <div class="text-danger">現在、STOCKCREW倉庫に在庫があります。</div>
                <div class="font-bold">プレミアム解約前に在庫の返送依頼をしてください</div>
                <div>※返送の完了を待たずに、解約を進めることができます。</div>
                <br>
                <div>解約後はプレミアム機能がすべて停止し、日割り・返金対応はございません。</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$router.push('/warehouse-sc/shipping/multi-channel')">
              在庫の返送依頼をする
              <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn" data-dismiss="modal" @click="$emit('close')">キャンセル</button>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  props: {
    canCancelContract: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    $('#cancel-contract-modal').modal('show')
    $('#cancel-contract-modal').on('hidden.bs.modal', (e) => {
      if (!$('#myModal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
  .btn-cancel {
    background-color: #a6a6a6;
    width: 150px;
  }
  @media (min-width:768px) {
    .modal-dialog {
      width: 730px;
    }
  }
  @media (min-width: 992px) and (max-width: 1200px) {
    #cancel-contract-modal .modal-dialog {
      width: 730px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/setting/CancelContractModal.vue